import { Department } from "@enums/department.enum";
import { ProductionStatus } from "@enums/productionStatus.enum";
import { Model } from "@interfaces/model.interface";

export interface Machine extends Model {
	averageWorkingDayLength?: number;
	cellNumber: string;
	department: Department;
	depth: number;
	documents: string;
	fridayDayShiftEndTime?: number;
	fridayDayShiftStartTime?: number;
	fridayNightShiftEndTime?: number;
	fridayNightShiftStartTime?: number;
	hourlyMachineRate?: number;
	manufacturer: string;
	mondayDayShiftEndTime?: number;
	mondayDayShiftStartTime?: number;
	mondayNightShiftEndTime?: number;
	mondayNightShiftStartTime?: number;
	name: string;
	ownerId?: number;
	productionStatus: ProductionStatus;
	qualityLoopDelay: number;
	rotationAmount: number;
	saturdayDayShiftEndTime?: number;
	saturdayDayShiftStartTime?: number;
	saturdayNightShiftEndTime?: number;
	saturdayNightShiftStartTime?: number;
	serialNumber: string;
	setUpCost?: number;
	siteId: number;
	sundayDayShiftEndTime?: number;
	sundayDayShiftStartTime?: number;
	sundayNightShiftEndTime?: number;
	sundayNightShiftStartTime?: number;
	thursdayDayShiftEndTime?: number;
	thursdayDayShiftStartTime?: number;
	thursdayNightShiftEndTime?: number;
	thursdayNightShiftStartTime?: number;
	tonnage: string;
	tuesdayDayShiftEndTime?: number;
	tuesdayDayShiftStartTime?: number;
	tuesdayNightShiftEndTime?: number;
	tuesdayNightShiftStartTime?: number;
	wednesdayDayShiftEndTime?: number;
	wednesdayDayShiftStartTime?: number;
	wednesdayNightShiftEndTime?: number;
	wednesdayNightShiftStartTime?: number;
	width: number;
	workingAreaX?: number;
	workingAreaY?: number;
	workingAreaZ?: number;
	xPosition: number;
	yPosition: number;
}

export class Machine implements Machine {
	cellNumber = "";
	department = Department.BackOffice;
	depth = 0;
	documents = "[]";
	manufacturer = "";
	name = "";
	productionStatus = ProductionStatus.Idle;
	qualityLoopDelay = 0;
	rotation = 0;
	siteId = 1;
	width = 0;
	xPosition = 0;
	yPosition = 0;

	constructor(data?: Partial<Machine>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}